'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilsFormat = require('@bibliocommons/utils-format');

var _utilsFormat2 = _interopRequireDefault(_utilsFormat);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('../styles/JacketCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JacketCover = function (_BcReactComponent) {
  _inherits(JacketCover, _BcReactComponent);

  function JacketCover(props) {
    _classCallCheck(this, JacketCover);

    var _this = _possibleConstructorReturn(this, (JacketCover.__proto__ || Object.getPrototypeOf(JacketCover)).call(this, props));

    _this.state = {
      imgSrc: null
    };
    return _this;
  }

  _createClass(JacketCover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.validateImage();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_immutable2.default.is(this.props.src, nextProps.src)) {
        this.props = nextProps;
        this.setState({ imgSrc: this.getDefaultImage() });
        this.validateImage();
      }
    }
  }, {
    key: 'getSourceImage',
    value: function getSourceImage() {
      if (typeof this.props.src === 'string') {
        if (this.props.src.indexOf('ftp://') !== 0) {
          return [this.props.src];
        }
      }

      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
        return _lodash2.default.compact([this.getLocalImageUrl(), this.props.src.get(this.props.size)]);
      }

      return [];
    }
  }, {
    key: 'getLocalImageUrl',
    value: function getLocalImageUrl() {
      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
        var localUrl = this.props.src.get('local_url');
        var isUrlHttp = localUrl && localUrl.indexOf('http://') !== -1;

        // Use core CDN for image proxying http links to https
        if (this.context.coreCdnHost && isUrlHttp) {
          localUrl = this.context.coreCdnHost + '/image_proxy?url=' + localUrl;
        }

        return localUrl;
      }

      return null;
    }
  }, {
    key: 'validateImage',
    value: function validateImage() {
      var _this2 = this;

      var currentImageIndex = 0;
      var src = this.getSourceImage();

      if (src.length > 0) {
        var testImage = new Image();

        testImage.onload = function () {
          if (testImage.width > 1 && testImage.height > 1) {
            _this2.setState({ imgSrc: testImage.src });
          }
          currentImageIndex += 1;
        };

        testImage.onerror = function () {
          if (src.length > currentImageIndex + 1) {
            currentImageIndex += 1;
            testImage.src = src[currentImageIndex];
          }
        };
        testImage.src = src[0];
      }
    }
  }, {
    key: 'renderDefault',
    value: function renderDefault() {
      if (this.props.renderDefault) {
        return this.props.renderDefault();
      }

      return this.renderImage(_utilsFormat2.default.getDefaultImage(this.props.format));
    }
  }, {
    key: 'renderImage',
    value: function renderImage(src) {
      var jacketClass = (0, _classnames2.default)('cp-jacket-cover', {
        'img-responsive': this.props.responsive,
        'drop-shadow': this.props.dropShadow
      });

      return _react2.default.createElement('img', {
        alt: this.props.alt,
        src: src,
        className: jacketClass,
        'data-test-id': this.props.testId });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.imgSrc) {
        return this.renderImage(this.state.imgSrc);
      }
      return this.renderDefault();
    }
  }]);

  return JacketCover;
}(_baseBcReactComponent2.default);

JacketCover.propTypes = {
  format: _react.PropTypes.string,
  src: _react.PropTypes.oneOfType([_react.PropTypes.string, _reactImmutableProptypes2.default.map, _reactImmutableProptypes2.default.mapOf({
    local_url: _react.PropTypes.string,
    large: _react.PropTypes.string,
    medium: _react.PropTypes.string,
    small: _react.PropTypes.string,
    type: _react.PropTypes.string
  })]),
  border: _react.PropTypes.bool,
  dropShadow: _react.PropTypes.bool,
  size: _react.PropTypes.string,
  responsive: _react.PropTypes.bool,
  testId: _react.PropTypes.string,
  renderDefault: _react.PropTypes.func
};

JacketCover.defaultProps = {
  size: 'medium',
  responsive: false,
  border: false,
  dropShadow: false
};

JacketCover.contextTypes = {
  coreCdnHost: _react.PropTypes.string
};

exports.default = JacketCover;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/jacket-cover/lib/components/JacketCover.component.js
// module id = 548
// module chunks = 0 3 4 9